import React from "react";

import "./MiniContainer.scss";

function MiniContainer({children}) {
  return (
    <div className="mini-container">
      {children}
    </div>
  );
};

export default MiniContainer;